class ProductCardSwatches extends HTMLElement {
  constructor() {
    super()

    this.imageWrapper = this.closest(".product-wrap").querySelector(".product-image__wrapper");
    this.link = this.closest(".product-wrap").querySelector(".product-wrap__link");
    this.ctaLinks = this.closest(".product-wrap").querySelectorAll("a.fsw-cta:not(.addgift)");
    this.titleEl = this.parentNode.querySelector(".product-thumbnail__title");
    this.template = this.querySelector("template").content;

    this.onChangeListener = this.onChange.bind(this);
  }

  connectedCallback() {
    this.classList.add("mounted");
    this.addEventListener("change", this.onChangeListener);
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.onChangeListener);
  }

  onChange(event) {
    const id = event.target.dataset.id;
    const targetContainer = this.template.querySelector(`[data-id="${id}"]`);
    if (!targetContainer) return;

    const newImage = targetContainer.querySelector("img");
    if (newImage) {
      const currentImage = this.imageWrapper.querySelector("img");
      if (currentImage) currentImage.replaceWith(newImage.cloneNode(true));
    }

    const newLink = targetContainer.querySelector("a");
    if (newLink) {
      this.link.href = newLink.href;
      this.ctaLinks.forEach((cta) => {
        cta.href = newLink.href;
      });
    }

    const newTitle = targetContainer.querySelector("p");
    if (newTitle) {
      this.titleEl.textContent = newTitle.textContent;
    }
  }
}

if (!customElements.get("product-card-swatches")) {
  customElements.define("product-card-swatches", ProductCardSwatches);
}